export default __webpack_public_path__ + "static/media/ant-design_file-add-outlined.b3e3a5bb.svg";